export const apiUrl = {
  login: "/open/login/",
  upload_file: "/file-uploads/",
  solutionAndObjective: "/solution-and-objectives/",
  updateSolutionObjectives: "/solution-and-objectives/update/",
  weight: "/criteria-weights/",
  criteriaAndReqirements: "/criteria-and-requirements/",
  rfpEvaluation: "/rfp-response-eval/",
  coreBusinessCheck: "/core-business-problem/check/",
  coreBusinessObjective: "/core-business-problem/check/sufficient/objectives/",
  generateSections: "/core-business-problem/generate/sections/",
  generateCriteria: "/core-business-problem/generate/criteria/",
  rfpScore: "/rfp-response-score/",
  generateRequirements: "/core-business-problem/generate/criteria/requirements/",
  saveExit: "/rfp/save-exists/stage",
  stakeHolder: "/user/stakeholder/",
  rfp: "rfp",
  question: "question",
  memo: "memo",
  vendorGuidelineDetails: "rfp/vendor/guideline/details/",
  vendorGuidelineDetailsExport: "rfp/vendor/guideline/export/",
  sendQuestionnaireToVendor: "analysis/rfp/send/vendors/",
  createSubscription: "user/create_subscription/",
  invoices: "user/subscription/invoices/",
  paymentMethods: "user/subscritions/payment-methods/",
  buyCredit: "user/buy/credit/",
  planDetails : "subscriptions/details/",
  cancelSubscription: "user/subscription/cancel/",
  contactSales: "user/subscription/request-demo/",
  chatbot: "chatbot/streaming/",
  chatbotHistory: "chatbot/history/",
  companyUsers: "company/users/",
  hr: "/hr/vertical/"
};